<template>
  <SignupDetail
    v-if="!invalidKey"
    :invitation="invitation"
    :inviteKey="inviteKey"
  />

  <InvalidInvitationKey v-else />
</template>
<script>
import { AccountService } from "@/services"
import SignupDetail from "@/components/utils/SignupDetail.vue"
import InvalidInvitationKey from "@/components/utils/InvalidInvitationKey.vue"

export default {
  components: {
    SignupDetail,
    InvalidInvitationKey
  },
  data() {
    return {
      invalidKey: false,
      inviteKey: this.$route.params.key,
      invitation: { email: "" }
    }
  },
  methods: {
    initialize() {
      const $ = this
      if (this.inviteKey) {
        // Check if the key is valid
        // If the key is not valid show that is not valid
        AccountService.getInvitation($, this.inviteKey)
          .then(result => {
            $.invitation = result.data
          })
          .catch(error => {
            $.invalidKey = true
          })
      }
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
